<div [attr.aria-hidden]="isLoading ? 'true' : 'false'">
  <div id="thesaurusHeaderWrapper" class="row">
    <h1>{{'title_page' | i18next}}</h1>
    <p>{{'thesauriText' | i18next}}</p>
  </div>
</div>
<ngx-spinner 
    name="index-spinner"
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate"
>
    <p aria-live="polite" style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

  <ng-template #thesauriContainer>
    <div id="thesauriList">
      <ul class="bullet">
        <li *ngFor="let thesaurus of thesauri; let i = index">
          <a id="thesauriListLink-{{i}}" routerLink="/thesaurus/{{thesaurus.id}}" queryParamsHandling="preserve" title="{{thesaurus.name}}">{{thesaurus.name}}</a>
        </li>
      </ul>
    </div>
  </ng-template>
<ng-container *ngIf="isServiceError(); then errorContainer else thesauriContainer"></ng-container>

<ng-template #errorContainer>
  <app-service-error id="errorMsg-Thesauri"></app-service-error>
</ng-template>

